<ion-content class="modal-border">
  <ion-header>
    <ion-toolbar> </ion-toolbar>
  </ion-header>

  <div class="ion-padding">
    <div *ngIf="loadingDone == false">
      <ion-label>Loading in progress, please wait...</ion-label>
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    </div>

    <div *ngIf="loadingDone == true">
      <ion-item>
        <ion-label>Click on a Equipment to select</ion-label>
      </ion-item>
      <ion-grid>
        <ion-row>
          <div *ngFor="let equipment of equipmentList;">
            <ion-col
              class="grid-block"
              (click)="onEquipmentSelect($event,equipment)"
            >
              <div *ngIf="equipment?.VendorEquipmentPictureContent_GUID != ''">
                <img
                  class="media-thumbnail-img"
                  style="padding: 20px; padding-bottom: 5px"
                  (error)="globals.onThumbnailError($event,'blank.jpg')"
                  src="{{globals.GetXRSCustomContentURL() + 'Thumbnails/' + equipment?.VendorEquipmentPictureContent_GUID + '.jpg'}}"
                />
              </div>

              <div
                style="
                  padding: 20px;
                  padding-top: 0px;
                  padding-bottom: 5px;
                  width: 200px;
                "
              >
                <ion-label style="font-weight: bold; width: 30px"
                  >{{equipment.Name}}</ion-label
                ><br />
                <ion-label style="font-weight: bold; width: 30px"
                  >{{equipment.Description}}</ion-label
                ><br />
                <ion-label>{{equipment.Serial}}</ion-label>
              </div>
            </ion-col>
          </div>
        </ion-row>
      </ion-grid>
      <ion-row>
        <ion-col class="modal-ion-col-bottom-buttons" style="left: 0">
          <ion-button
            (click)="onCloseUpload()"
            class="menuitem-ion-button"
            style="width: 110% !important; left: 0"
            >Close</ion-button
          >
        </ion-col>
      </ion-row>
    </div>
  </div>
</ion-content>
